import {
	type PartnerCalendarRequestDto,
	postPartnersCalendar,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { PartnerCalendarRequest } from "Partner/Api/PartnerCalendarExtensionsApi";
import { useQuery } from "@tanstack/react-query";

export const getPartnerCalendarQueryKey = (request: PartnerCalendarRequest) => [
	"partners",
	"calendar",
	request.marketId,
	request.startDate,
	request.endDate,
	request.page,
	request.limit,
	request.verticalIds,
	request.regions,
	request.skills,
	request.sortByAvailabilityDate,
];

export function usePartnerCalendarQuery(
	request: PartnerCalendarRequest,
	enabled = true,
) {
	return useQuery({
		queryKey: getPartnerCalendarQueryKey(request),
		queryFn: processResponse(() =>
			postPartnersCalendar(request as PartnerCalendarRequestDto),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		staleTime: 20_000,
		gcTime: 2 * 60_000,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
		enabled:
			enabled && !!request.marketId && !!request.startDate && !!request.endDate,
	});
}
